/**
 * Спільні стилі MUI для полів у таблиці редактора техкарти та сумісних таблицях (напр. «Матеріали»).
 */

/** Один стиль для полів рядка матеріалу (MUI outlined, однакова висота з Autocomplete). */
export const TECH_CARD_MUI_FIELD_SX = {
    width: "100%",
    "& .MuiOutlinedInput-root": {
        minHeight: 40,
        fontSize: "0.875rem",
    },
    "& .MuiOutlinedInput-notchedOutline": {
        top: 0,
        "& legend": {
            display: "none",
        },
    },
};

/** Панель списку автокомпліту — тінь і вигляд як у випадаючого MUI Select (Menu/Paper). */
export const TECH_CARD_AUTOCOMPLETE_COMPONENTS_PROPS = {
    paper: {
        elevation: 8,
        sx: (theme) => ({
            marginTop: theme.spacing(0.5),
            borderRadius: theme.shape.borderRadius,
            border: `1px solid ${theme.palette.divider}`,
        }),
    },
};

export const TECH_CARD_AUTOCOMPLETE_LISTBOX_SX = (theme) => ({
    paddingTop: theme.spacing(0.5),
    paddingBottom: theme.spacing(0.5),
    "& .MuiAutocomplete-option": {
        fontSize: "0.875rem",
        minHeight: "auto",
        alignItems: "flex-start",
        paddingTop: theme.spacing(1),
        paddingBottom: theme.spacing(1),
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(2),
        borderRadius: theme.shape.borderRadius,
        marginLeft: theme.spacing(0.5),
        marginRight: theme.spacing(0.5),
        "&.Mui-focused": {
            backgroundColor: theme.palette.action.hover,
        },
        '&[aria-selected="true"]': {
            backgroundColor: theme.palette.action.selected,
        },
        "&.Mui-focused.Mui-focusVisible": {
            backgroundColor: theme.palette.action.hover,
        },
    },
});
